import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=17ca2927"
import script from "./order-details.vue?vue&type=script&lang=ts"
export * from "./order-details.vue?vue&type=script&lang=ts"
import style0 from "./order-details.vue?vue&type=style&index=0&id=17ca2927&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ca2927')) {
      api.createRecord('17ca2927', component.options)
    } else {
      api.reload('17ca2927', component.options)
    }
    module.hot.accept("./order-details.vue?vue&type=template&id=17ca2927", function () {
      api.rerender('17ca2927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/order-details.vue"
export default component.exports